import { ILayoutConfiguration } from "@valenzinsights/react-core";

export const layoutConfig: ILayoutConfiguration = {
	component: {
		navigationPanel: {
			drawerWidth: 200,
			minDrawerWidth: 60,
			persistentDrawerIcons: true,
		},
		toolbar: {
			minHeight: 50,
			height: 50,
			paddingTop: 0,
			paddingBottom: 2,
		},
		commandbar: {
			height: 40,
		},
		rightSidebar: {
			width: 50,
			buttonHeight: 50,
		},
		rightDrawerPanel: {
			width: 250,
		},
		headerMenu: {
			headerMenuContainer: {
				display: "flex",
				justifyContent: "start",
				gap: 2,
				paddingLeft: 2,
			},
			menuButton: {},
		},
	},
};
